"use client";
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Button } from '@heroui/react';

const HeroBanner = ({ big = true, productsCallback, initialQuery = '', setDoneLoading }: any) => {
  const [query, setQuery] = useState(initialQuery);
  const [suggestions, setSuggestions] = useState([]);
  const [focus, setFocus] = useState(false);
  const router = useRouter();

  useEffect(() => {
    initialQuery.length > 0 && searchProducts(query);
  }, [initialQuery])

  async function searchProducts(query) {
    if (!query) {
      setSuggestions([]);
      return;
    }

    try {
    const response = await fetch(`/api/products/search?query=${encodeURIComponent(query)}`);
    const data = await response.json();

    if (data.success) {
      console.log(data);
      setSuggestions(data.data); // Update suggestions with the search results

      productsCallback !== null && productsCallback(data.data)
    } else {
      console.error("Error:", data.error);
    }
  } catch {

  } finally {
    setDoneLoading && setDoneLoading(true);
  }
  }

  return (
    <div className={`relative w-full mt-5 ${big ? "h-[400px] md:h-[500px] lg:h-[500px]" : "h-[300px] md:h-[400px] lg:h-[400px]"}`}>
      {/* Background Image - Show variety of Palestinian products */}
      <div className="absolute inset-0 z-9">
        
          <Image
            src="/uploads/happy-kids.jpg" // Show food, crafts, art, textiles
            alt="Palestinian products collection"
            className='blur-sm opacity-40 object-cover'
            quality={100}
            fill
            priority={true}
          />
        
        
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        {big &&
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 drop-shadow-lg">
              Shop With Purpose
            </h1>
            <p className="text-lg md:text-xl text-white mb-8 max-w-2xl drop-shadow-md">
              Every purchase supports Palestinian artisans, farmers, and businesses
            </p>
          </div>
        }

        {/* Search Field */}
        <div className="w-full max-w-2xl">
          <div className="relative">
            <input
              type="text"
              placeholder="Search olive oil, ceramics, dates, embroidery..."
              value={query}
              onFocus={() => setTimeout(() => setFocus(true), 200)} // Set focus to true when input is focused
              onBlur={() => setTimeout(() => setFocus(false), 200)}
              onChange={(e) => {
                setQuery(e.target.value);
                searchProducts(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault(); // Prevent default form submission behavior if inside a form
                  setQuery(e.target.value);
                  router.push(`/search/${query.replaceAll(' ', '%20')}`)
                }
              }}
              className="w-full py-4 px-6 rounded-full border-none focus:ring-2 focus:ring-primary-500 focus:outline-none shadow-lg text-white"
            />
            <button onClick={() => router.push(`/search/${query}`)} className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-primary-500 hover:bg-primary-600 text-white rounded-full p-3 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
            {query && suggestions.length > 0 && focus && (
              <div className="absolute left-0 top-16 w-full bg-white shadow-lg rounded-lg max-h-60 overflow-y-auto z-10">
                <ul className="space-y-2 py-2 px-4">
                  {suggestions.map((product) => (
                    <li onClick={() => {

                      setQuery(product.name);
                      router.push(`/search/${product.name}`);


                    }} key={product._id} className="flex items-center space-x-3 cursor-pointer hover:bg-gray-200 p-2 rounded-lg">
                      {product.imagePath && (
                        <Image
                          src={product.imagePath}
                          alt={product.name}
                          width={40}
                          height={40}
                          className="rounded-md"
                        />
                      )}
                      <span className="text-black">{product.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Display search recommendations */}

        </div>

        {/* Product category highlights */}
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <Button onPress={() => setQuery("Olive Oil")} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white border border-white/20">
            Olive Oil
          </Button>
          <Button onPress={() => setQuery("Embroidery")} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white border border-white/20">
            Embroidery
          </Button>
          <Button onPress={() => setQuery("Ceramics")} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white border border-white/20">
            Ceramics
          </Button>
          <Button onPress={() => setQuery("Dates")} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white border border-white/20">
            Dates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
